export const UPDATE_PROGRESS = 'UPDATE_PROGRESS';

export const receiveUpdatedProgress = (promptId, promptQueue, assessmentType, allPromptIds) => ({
    type: UPDATE_PROGRESS,
    promptQueue,
    promptId,
    assessmentType,
    allPromptIds
});

export const updateProgress = (promptId) => (dispatch, getState) => {
    const state = getState();
    const { app, session, entities } = state;

    const promptQueue = session.promptQueue;
    const assessmentType = app.assessment.type;
    const allPromptIds = Object.keys(entities.prompts);
    
    return dispatch(receiveUpdatedProgress(promptId, promptQueue, assessmentType, allPromptIds));
};